import { NgModule } from "@angular/core";
import { NgbAlertModule } from "@ng-bootstrap/ng-bootstrap";
import { QrCodeReaderButtonComponent } from "clearline-common";
import { CommonFeatureModule } from "../common/common-feature.module";
import {
  CouponCardComponent,
  CouponDetailsComponent,
  CouponSearchFormComponent,
  ValidateCouponDetailsComponent,
  ValidateCouponModalComponent
} from "./validate-coupon-modal";

@NgModule({
  declarations: [
    ValidateCouponModalComponent,
    ValidateCouponDetailsComponent,
    CouponSearchFormComponent,
    CouponCardComponent,
    CouponDetailsComponent
  ],
  imports: [CommonFeatureModule, NgbAlertModule, QrCodeReaderButtonComponent],
  exports: [ValidateCouponModalComponent]
})
export class ValidateCouponModule {}
